import { render, staticRenderFns } from "./CreateMaterialform.vue?vue&type=template&id=7bc546ae&"
import script from "./CreateMaterialform.vue?vue&type=script&lang=js&"
export * from "./CreateMaterialform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports